import React, { useContext, useState } from 'react';
import { CompanyContext } from '../../../../../context/CompanyContext';
import { MetricFilter } from '../../../../../types/metrics/metricFilter';
import { DropdownMultiSelect } from '../../../../../ui/components/Dropdown';
import Icon, { IconType } from '../../../../../ui/icons/Icon';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { CompanyConnectionContext } from '../../../../../context/CompanyConnectionContext';

interface CompanySearchSelectProps {
  filter: MetricFilter;
  setFilter: (filter: MetricFilter) => void;
}

export default function CompanySearchSelect({ filter, setFilter }: CompanySearchSelectProps) {
  const { companies, currentCompany } = useContext(CompanyContext);
  const { companyConnections } = useContext(CompanyConnectionContext);

  const connections = new Set(
    [...Array.from(companyConnections.values())]
      .filter(cc => cc.parentId === currentCompany.id || cc.companyId === currentCompany.id)
      .map(cc => [cc.companyId, cc.parentId])
      .flat(),
  );

  const [items, setItems] = useState(
    Array.from(companies.values())
      .filter(c => connections.has(c.id))
      .sort((a, b) => (b.partner ? 1 : 0) - (a.partner ? 1 : 0) || a.name.localeCompare(b.name)),
  );

  const selected = new Set(filter.companyIds);
  const companyIds = items.map(c => c.id).filter(id => !selected.has(id));

  return (
    <DropdownMultiSelect
      items={companyIds}
      values={selected}
      onSelect={id => {
        filter.companyIds = Array.from(new Set([...filter.companyIds, id]));
        setFilter(new MetricFilter(filter));
      }}
      textBuilder={item => companies.get(item)?.name || ''}
      inputItemBuilder={(item, text) => {
        return (
          <div className='flex items-center gap-2 rounded-2 border p-1 text-sm'>
            <p>{text}</p>
            <Icon
              type={IconType.x}
              onClick={() => {
                filter.companyIds = filter.companyIds.filter(id => id !== item);
                setFilter(new MetricFilter(filter));
              }}
              size={'size-4'}
            />
          </div>
        );
      }}
      label={''}
      placeholder={t(TranslationKey.selectCompany).singular.label}
    />
  );
}
